import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  handleAddStatusColumn,
  handleDeleteStatusColumn,
} from "../../api/statusColumn.api";

interface StatusColumnState {
  loading: boolean;
  title: string;
  columns: { status: string }[];
}

const initialState: StatusColumnState = {
  title: "",
  loading: false,
  columns: [],
};

// Add status column
export const addStatusColumn = createAsyncThunk(
  "/leads/addStatus",
  async (columnTitle: string, { rejectWithValue }) => {
    try {
      return await handleAddStatusColumn(columnTitle);
    } catch (error: any) {
      return rejectWithValue(error?.message || "Failed to add status column");
    }
  }
);

// Delete status column
export const deleteStatusColumn = createAsyncThunk(
  "/leads/deleteStatus",
  async (columnId: string, { rejectWithValue }) => {
    try {
      return await handleDeleteStatusColumn(columnId);
    } catch (error: any) {
      return rejectWithValue(
        error?.message || "Failed to delete status column"
      );
    }
  }
);

const statusColumnSlice = createSlice({
  name: "statusColumn",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Add Status Column
    builder.addCase(addStatusColumn.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(addStatusColumn.fulfilled, (state, action) => {
      state.loading = false;
      state.title = action.payload.title;
      state.columns.push(action.payload);
    });
    builder.addCase(addStatusColumn.rejected, (state) => {
      state.loading = false;
    });

    // Delete Status Column
    builder.addCase(deleteStatusColumn.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteStatusColumn.fulfilled, (state, action) => {
      state.loading = false;
      state.columns = state.columns.filter(
        (column) => column.status !== action.payload.status
      );
    });
    builder.addCase(deleteStatusColumn.rejected, (state) => {
      state.loading = false;
    });
  },
});

export default statusColumnSlice.reducer;
